import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { styles } from "./styles";
import { connect, ConnectedProps } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, useFormikContext } from "formik";
import IOSSwitch from "../IOSSwitch";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import VisibilityIcon from "@material-ui/icons/VisibilityOutlined";
import ReactivateIcon from "@material-ui/icons/Refresh";
import WarningIcon from "@material-ui/icons/Report";
import DeleteIcon from "@material-ui/icons/Delete";
import IconReactivate from "../../../../assets/iconos/reactivate.svg";

import * as actionCreators from "../../../../store/actions";
import Loading from "../../../UI/Loading/Loading";
import { IsMobileContext } from "../../../UI/IsMobile/IsMobile";
import { Service } from "../../types";
import { SelectContactType } from "./SelectContactType";
import { DeleteContactoApplication } from "../../../../store/actions/administracionActions";

type LocationState = {
  id?: string;
};

interface OwnProps {}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  fetchApplication: (id: number) => dispatch(actionCreators.GetApplication(id)),
  renewCredentialsToApp: (id: number) =>
    dispatch(actionCreators.ResetCredentials(id)),
  saveApplicationData: (app: any) =>
    dispatch(actionCreators.SaveApplication(app)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PublicProps = OwnProps;
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PublicProps & PropsFromRedux & WithStyles<typeof styles>;

const validationSchema = Yup.object({
  nombre: Yup.string().required("Campo obligatorio"),
  url: Yup.string().required(),
  urlIcono: Yup.string().required(),
  cuilOperador: Yup.string().when("enviaComunicaciones", {
    is: true,
    then: (schema: any) => schema.required("Campo obligatorio"),
    otherwise: (schema: any) => schema.notRequired(),
  }),
  descripcion: Yup.string().max(500, "Máximo 500 caracteres"),
  mensaje: Yup.string()
    .nullable()
    .max(2000, "Máximo 2000 caracteres")
    .when("mostrarMensaje", {
      is: true,
      then: (schema: any) => schema.required("Campo obligatorio"),
      otherwise: (schema: any) => schema.notRequired(),
    }),
  mensajeMovil: Yup.string()
    .nullable()
    .max(2000, "Máximo 2000 caracteres")
    .when("muestraMensajeMovil", {
      is: true,
      then: (schema: any) => schema.required("Campo obligatorio"),
      otherwise: (schema: any) => schema.notRequired(),
    }),
});

const initialValues = {
  nombre: "",
  url: "",
  urlIcono: "",
  cuilOperador: "",
  descripcion: "",
  impedirAcceso: false,
  soloCiudadanos: false,
  enviaComunicaciones: false,
  muestraPanel: false,
  externa: false,
  relacionable: false,
  delegable: false,
  mostrarMensaje: false,
  mensaje: "",
  muestraMensajeMovil: false,
  mensajeMovil: "",
  primaryEmail: { email: "", tipo: "1", id: undefined },
  secondaryEmail: { email: "", tipo: "1", id: undefined },
  primaryPhone: { numero: "", tipo: "1", id: undefined },
  secondaryPhone: { numero: "", tipo: "1", id: undefined },
  primaryWhatsapp: { numero: "", tipo: "2", id: undefined },
  secondaryWhatsapp: { numero: "", tipo: "2", id: undefined },
};

const FormService: React.FC<Props> = (props) => {
  const {
    classes,
    fetchApplication,
    saveApplicationData,
    renewCredentialsToApp,
  } = props;
  const [_loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams<LocationState>();
  const location = useLocation();
  const [serviceData, setServiceData] = useState<
    | (Service & {
        primaryEmail?: string;
        secondaryEmail?: string;
        primaryPhone?: string;
        secondaryPhone?: string;
        primaryWhatsapp?: string;
        secondaryWhatsapp?: string;
      })
    | null
  >(null);
  const isMobile = useContext(IsMobileContext);
  const [modal, setModal] = useState(false);
  const [renewModal, setRenewModal] = useState(false);

  const isViewing = location.pathname.startsWith("/vista-servicio/");
  const isEditing = location.pathname.startsWith("/editar-servicio/");

  function mapServiceData(data: any) {
    const getPhoneByType = (tipo: string, index: number) =>
      data.telefonos?.filter((t: any) => t.tipo === tipo)[index] || {
        numero: "",
        tipo,
        id: undefined,
      };

    const getEmail = (index: number) =>
      data.emails?.[index] || { email: "", tipo: "1", id: undefined };

    const formData = {
      ...data,
      primaryPhone: getPhoneByType("1", 0),
      secondaryPhone: getPhoneByType("1", 1),
      primaryWhatsapp: getPhoneByType("2", 0),
      secondaryWhatsapp: getPhoneByType("2", 1),
      primaryEmail: getEmail(0),
      secondaryEmail: getEmail(1),
    };

    setServiceData(formData);
  }

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    fetchApplication(Number(id)).then((data: any) => {
      mapServiceData(data);
      setLoading(false);
    });
  }, [fetchApplication, id]);

  const handleCancel = () => {
    navigate("/administracion-servicios");
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const handleRenewTokens = () => {
    setModal(false);
    setRenewModal(true);
  };

  const handleRenewCredentials = () => {
    renewCredentialsToApp(Number(id)).then(() => {
      setRenewModal(false);
      setLoading(true);

      fetchApplication(Number(id)).then((data: any) => {
        mapServiceData(data);
        setLoading(false);
      });
    });
  };

  const handleDeleteContact = async (contactId: number, type: string) => {
    const eliminado = await DeleteContactoApplication(contactId, type);
    if (!eliminado) return;

    fetchApplication(Number(id)).then((data: any) => {
      mapServiceData(data);
      setLoading(false);
    });
  };

  function mapFormatData(
    values: Service & {
      primaryEmail?: { email: string; tipo: string; id?: number };
      secondaryEmail?: { email: string; tipo: string; id?: number };
      primaryPhone?: { numero: string; tipo: string; id?: number };
      secondaryPhone?: { numero: string; tipo: string; id?: number };
      primaryWhatsapp?: { numero: string; tipo: string; id?: number };
      secondaryWhatsapp?: { numero: string; tipo: string; id?: number };
    }
  ) {
    const {
      emails = [],
      telefonos = [],
      primaryEmail,
      secondaryEmail,
      primaryPhone,
      secondaryPhone,
      primaryWhatsapp,
      secondaryWhatsapp,
      ...rest
    } = values;

    const finalEmails = [primaryEmail, secondaryEmail]
      .filter(
        (e): e is { email: string; tipo: string; id?: number } => !!e?.email
      )
      .map((emailObj) => ({
        email: emailObj.email,
        tipo: emailObj.tipo || "1",
        ...(emailObj.id && { id: emailObj.id }),
      }));

    const finalTelefonos = [
      primaryPhone,
      secondaryPhone,
      primaryWhatsapp,
      secondaryWhatsapp,
    ]
      .filter(
        (t): t is { numero: string; tipo: string; id?: number } => !!t?.numero
      )
      .map((telObj) => ({
        numero: telObj.numero,
        tipo: parseInt(telObj.tipo || "1", 10),
        ...(telObj.id && { id: telObj.id }),
      }));

    return {
      ...rest,
      IdApplication: id || undefined,
      emails: finalEmails,
      telefonos: finalTelefonos,
    };
  }

  if (_loading) return <Loading loading={_loading} />;

  return (
    <>
      <Modal
        open={modal}
        onClose={() => setModal(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        className={classes.modal}
      >
        <Box className={classes.modalContent}>
          <Typography id="modal-title" className={classes.titleMobile}>
            Información de claves
          </Typography>
          {isEditing && (
            <Box className={classes.modalRow} marginBottom={2}>
              <div className={classes.buttonTokensContainer}>
                <Button
                  className={classes.buttonTokens}
                  onClick={handleRenewTokens}
                >
                  <ReactivateIcon /> <label>Reestablecer tokens</label>
                </Button>
              </div>
            </Box>
          )}
          <Box className={classes.modalRow}>
            <TextField
              name="secret"
              label="Secret"
              variant="outlined"
              value={serviceData?.secret || " "}
              className={classes.textField}
              fullWidth={isMobile}
              disabled
            />
            <Button onClick={() => copyToClipboard(serviceData?.secret || "")}>
              Copiar
            </Button>
          </Box>
          <Box className={classes.modalRow}>
            <TextField
              name="salt"
              label="Salt"
              variant="outlined"
              value={serviceData?.salt || " "}
              className={classes.textField}
              fullWidth={isMobile}
              disabled
            />
            <Button onClick={() => copyToClipboard(serviceData?.salt || "")}>
              Copiar
            </Button>
          </Box>
          <Box className={classes.modalRow}>
            <TextField
              name="apiKey"
              label="ApiKey"
              variant="outlined"
              value={serviceData?.apiKey || ""}
              className={classes.textField}
              fullWidth={isMobile}
              disabled
            />
            <Button onClick={() => copyToClipboard(serviceData?.apiKey || "")}>
              Copiar
            </Button>
          </Box>
        </Box>
      </Modal>
      {renewModal && (
        <Modal
          open={renewModal}
          onClose={() => setRenewModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className={classes.modal}
        >
          <Box className={classes.modalWarningContent}>
            <img
              src={IconReactivate}
              className={classes.modalIcon}
              alt="eliminar"
            ></img>
            <Typography id="modal-title" className={classes.modalTitle}>
              Refrescar claves
            </Typography>
            <Typography
              id="modal-subtitle"
              className={classes.modalDescription}
            >
              ¿Deseas confirmar el refresco de las claves?
            </Typography>
            <Box className={classes.warningBox}>
              <WarningIcon />
              <Typography
                id="modal-description"
                className={classes.warningDescription}
              >
                Las claves antiguas dejarán de funcionar. Comparte las nuevas
                con el responsable del servicio para mantener la conexión.
              </Typography>
            </Box>
            <div className={classes.modalButtons}>
              <Button
                className={classes.modalCancel}
                onClick={() => setRenewModal(false)}
              >
                Cerrar
              </Button>
              <Button
                className={classes.modalAccept}
                onClick={handleRenewCredentials}
              >
                Confirmar
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      <Formik
        enableReinitialize
        initialValues={serviceData || initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const app = mapFormatData(values as any);
          saveApplicationData(app)
            .then(() => {
              navigate("/administracion-servicios");
            })
            .catch((err: any) => {
              console.error("Error al guardar:", err);
            });
        }}
      >
        {({ values, errors, handleChange, handleSubmit }) => {
          return (
            <>
              <ScrollToFieldError />
              <Form onSubmit={handleSubmit} className={classes.root}>
                {isMobile && (
                  <h2 className={classes.titleMobile}>{`${
                    isEditing ? "Edición" : isViewing ? "Detalle" : "Alta"
                  } de Servicio`}</h2>
                )}
                <section className={classes.formGroup}>
                  <h2>Información General</h2>
                  <div className={classes.inputsGroup}>
                    <Field
                      as={TextField}
                      name="nombre"
                      label="Nombre Servicio"
                      variant="outlined"
                      className={classes.textField}
                      fullWidth={isMobile}
                      sx={{ minWidth: isMobile ? "auto" : "400px" }}
                      error={Boolean(errors.nombre)}
                      helperText={errors.nombre}
                      disabled={isViewing}
                    />
                    <Field
                      as={TextField}
                      name="url"
                      label="URL Servicio"
                      variant="outlined"
                      className={classes.textField}
                      fullWidth={isMobile}
                      error={Boolean(errors.url)}
                      helperText={errors.url}
                      disabled={isViewing}
                    />
                    <Field
                      as={TextField}
                      name="urlIcono"
                      label="URL Icono"
                      variant="outlined"
                      className={classes.textField}
                      fullWidth={isMobile}
                      error={Boolean(errors.urlIcono)}
                      helperText={errors.urlIcono}
                      disabled={isViewing}
                    />
                    <Field
                      as={TextField}
                      name="cuilOperador"
                      label="CUIL Operador"
                      variant="outlined"
                      className={classes.textField}
                      fullWidth={isMobile}
                      error={Boolean(errors.cuilOperador)}
                      helperText={errors.cuilOperador}
                      disabled={isViewing}
                    />
                    <Field
                      as={TextField}
                      name="descripcion"
                      label="Descripción"
                      variant="outlined"
                      className={classes.textField}
                      fullWidth={isMobile}
                      sx={{ minWidth: isMobile ? "auto" : "600px" }}
                      error={Boolean(errors.descripcion)}
                      helperText={errors.descripcion}
                      disabled={isViewing}
                    />
                  </div>
                  <div className={classes.inputsGroup}>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.impedirAcceso}
                          onChange={handleChange}
                          name="impedirAcceso"
                          disabled={isViewing}
                        />
                        Impedir acceso
                      </label>
                    </div>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.soloCiudadanos}
                          onChange={handleChange}
                          name="soloCiudadanos"
                          disabled={isViewing}
                        />
                        Solo ciudadanos
                      </label>
                    </div>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.enviaComunicaciones}
                          onChange={handleChange}
                          name="enviaComunicaciones"
                          disabled={isViewing}
                        />
                        Envía comunicaciones
                      </label>
                    </div>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.relacionable}
                          onChange={handleChange}
                          name="relacionable"
                          disabled={isViewing}
                        />
                        Relacionable
                      </label>
                    </div>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.delegable}
                          onChange={handleChange}
                          name="delegable"
                          disabled={isViewing}
                        />
                        Delegable
                      </label>
                    </div>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.muestraPanel}
                          onChange={handleChange}
                          name="muestraPanel"
                          disabled={isViewing}
                        />
                        Muestra panel
                      </label>
                    </div>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.externa}
                          onChange={handleChange}
                          name="externa"
                          disabled={isViewing}
                        />
                        Externa
                      </label>
                    </div>
                    {(isViewing || isEditing) && (
                      <div className={classes.buttonTokensContainer}>
                        <Button
                          className={classes.buttonTokens}
                          onClick={() => setModal(true)}
                        >
                          {isViewing ? (
                            <>
                              <VisibilityIcon /> <label>Ver tokens</label>
                            </>
                          ) : (
                            <>
                              <ReactivateIcon />{" "}
                              <label>Reestablecer tokens</label>
                            </>
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </section>
                <section className={classes.formGroup}>
                  <h2>Información Desktop</h2>
                  <div className={classes.inputsGroup}>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.mostrarMensaje}
                          onChange={handleChange}
                          name="mostrarMensaje"
                          disabled={isViewing}
                        />
                        Mostrar mensaje Desktop
                      </label>
                    </div>
                  </div>
                  <Field
                    as={TextField}
                    name="mensaje"
                    label="Mensaje Desktop"
                    variant="outlined"
                    className={classes.textField}
                    fullWidth
                    error={Boolean(errors.mensaje)}
                    helperText={errors.mensaje}
                    disabled={isViewing}
                  />
                </section>
                <section className={classes.formGroup}>
                  <h2>Información Mobile</h2>

                  <div className={classes.inputsGroup}>
                    <div className={classes.switch}>
                      <label>
                        <IOSSwitch
                          checked={values.muestraMensajeMovil}
                          onChange={handleChange}
                          name="muestraMensajeMovil"
                          disabled={isViewing}
                        />
                        Mostrar mensaje Mobile
                      </label>
                    </div>
                  </div>
                  <Field
                    as={TextField}
                    name="mensajeMovil"
                    label="Mensaje Mobile"
                    variant="outlined"
                    className={classes.textField}
                    fullWidth
                    error={Boolean(errors.mensajeMovil)}
                    helperText={errors.mensajeMovil}
                    disabled={isViewing}
                  />
                </section>
                <section className={classes.formGroup}>
                  <h2>Información de Contacto </h2>
                  {/* Whatsapp */}
                  <div className={classes.contactGroup}>
                    <SelectContactType
                      label="Tipo de contacto"
                      options={["Whatsapp"]}
                      value="Whatsapp"
                      onChange={handleChange}
                      disabled={isViewing}
                      className={classes.textField}
                      fullWidth={isMobile}
                    />

                    <div className={classes.inputWithDelete}>
                      <Field
                        as={TextField}
                        name="primaryWhatsapp.numero"
                        label="ingresa el dato"
                        variant="outlined"
                        className={classes.textField}
                        fullWidth={isMobile}
                      />
                      <Button
                        onClick={() => {
                          const contacto = values.primaryWhatsapp;
                          if (
                            typeof contacto === "object" &&
                            contacto !== null &&
                            "id" in contacto &&
                            contacto.id
                          ) {
                            handleDeleteContact(contacto.id, "Telefono");
                          }
                        }}
                        disabled={isViewing}
                        className={classes.deleteButton}
                      >
                        <DeleteIcon style={{ color: "red" }} />
                      </Button>
                    </div>

                    <div className={classes.inputWithDelete}>
                      <Field
                        as={TextField}
                        name="secondaryWhatsapp.numero"
                        label="ingresa el dato"
                        variant="outlined"
                        className={classes.textField}
                        fullWidth={isMobile}
                      />
                      <Button
                        onClick={() => {
                          const contacto = values.secondaryWhatsapp;
                          if (
                            typeof contacto === "object" &&
                            contacto !== null &&
                            "id" in contacto &&
                            contacto.id
                          ) {
                            handleDeleteContact(contacto.id, "Telefono");
                          }
                        }}
                        disabled={isViewing}
                        className={classes.deleteButton}
                      >
                        <DeleteIcon style={{ color: "red" }} />
                      </Button>
                    </div>
                  </div>
                  {/* Telefono de contacto */}
                  <div className={classes.contactGroup}>
                    <SelectContactType
                      label="Tipo de contacto"
                      options={["Telefono de contacto"]}
                      value="Telefono de contacto"
                      onChange={handleChange}
                      disabled={isViewing}
                      className={classes.textField}
                      fullWidth={isMobile}
                    />
                    <div className={classes.inputWithDelete}>
                      <Field
                        as={TextField}
                        name="primaryPhone.numero"
                        label="ingresa el dato"
                        variant="outlined"
                        className={classes.textField}
                        fullWidth={isMobile}
                      />
                      <Button
                        onClick={() => {
                          const contacto = values.primaryPhone;
                          if (
                            typeof contacto === "object" &&
                            contacto !== null &&
                            "id" in contacto &&
                            contacto.id
                          ) {
                            handleDeleteContact(contacto.id, "Telefono");
                          }
                        }}
                        disabled={isViewing}
                        className={classes.deleteButton}
                      >
                        <DeleteIcon style={{ color: "red" }} />
                      </Button>
                    </div>
                    <div className={classes.inputWithDelete}>
                      <Field
                        as={TextField}
                        name="secondaryPhone.numero"
                        label="ingresa el dato"
                        variant="outlined"
                        className={classes.textField}
                        fullWidth={isMobile}
                      />
                      <Button
                        onClick={() => {
                          const contacto = values.secondaryPhone;
                          if (
                            typeof contacto === "object" &&
                            contacto !== null &&
                            "id" in contacto &&
                            contacto.id
                          ) {
                            handleDeleteContact(contacto.id, "Telefono");
                          }
                        }}
                        disabled={isViewing}
                        className={classes.deleteButton}
                      >
                        <DeleteIcon style={{ color: "red" }} />
                      </Button>
                    </div>
                  </div>
                  {/* Correo electrónico */}
                  <div className={classes.contactGroup}>
                    <SelectContactType
                      label="Tipo de contacto"
                      options={["Correo electrónico"]}
                      value="Correo electrónico"
                      onChange={handleChange}
                      disabled={isViewing}
                      className={classes.textField}
                      fullWidth={isMobile}
                    />

                    <div className={classes.inputWithDelete}>
                      <Field
                        as={TextField}
                        name="primaryEmail.email"
                        label="ingresa el dato"
                        variant="outlined"
                        className={classes.textField}
                        fullWidth={isMobile}
                      />
                      <Button
                        onClick={() => {
                          const contacto = values.primaryEmail;
                          if (
                            typeof contacto === "object" &&
                            contacto !== null &&
                            "id" in contacto &&
                            contacto.id
                          ) {
                            handleDeleteContact(contacto.id, "Email");
                          }
                        }}
                        disabled={isViewing}
                        className={classes.deleteButton}
                      >
                        <DeleteIcon style={{ color: "red" }} />
                      </Button>
                    </div>

                    <div className={classes.inputWithDelete}>
                      <Field
                        as={TextField}
                        name="secondaryEmail.email"
                        label="ingresa el dato"
                        variant="outlined"
                        className={classes.textField}
                        fullWidth={isMobile}
                      />
                      <Button
                        onClick={() => {
                          const contacto = values.secondaryEmail;
                          if (
                            typeof contacto === "object" &&
                            contacto !== null &&
                            "id" in contacto &&
                            contacto.id
                          ) {
                            handleDeleteContact(contacto.id, "Email");
                          }
                        }}
                        disabled={isViewing}
                        className={classes.deleteButton}
                      >
                        <DeleteIcon style={{ color: "red" }} />
                      </Button>
                    </div>
                  </div>
                </section>
                <div className={classes.containerButtons}>
                  <Button
                    className={classes.buttonCancel}
                    onClick={handleCancel}
                  >
                    {isViewing ? "Volver" : "Cancelar"}
                  </Button>
                  {!isViewing && (
                    <Button className={classes.buttonConfirm} type="submit">
                      {isEditing ? "Guardar" : "Confirmar alta"}
                    </Button>
                  )}
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

function ScrollToFieldError() {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating && Object.keys(errors).length > 0) {
      const errorField = document.querySelector(
        `[name="${Object.keys(errors)[0]}"]`
      );
      if (errorField) {
        errorField.scrollIntoView({ behavior: "smooth", block: "center" });
        (errorField as HTMLElement).focus({ preventScroll: true });
      }
    }
  }, [errors, isSubmitting, isValidating]);

  return null;
}

export default connector(
  withStyles(styles)(FormService)
) as React.ComponentType<PublicProps>;
